import { Grid, TextField, Typography, MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { Controller, useForm } from "react-hook-form";
import React, { useState, useEffect, Fragment } from 'react';
import { fieldDimensionOptions } from '../../../config/common';
import { getElementOnFocus } from '../../../store/global/selectors'
import { basic, validationMessages } from '../../../config/validations';
import UpdateCancel from "../../atoms/buttons/UpdateCancel";
import { booleanOptions } from '../../../config/common';
import { invokeGetService, invokePostService, setExpanded } from '../../../store/global/actions'
import LoaderWithProgress from '../../atoms/loader/LoaderWithProgress';
import { validateNonAsciiChars } from '../../../utils/commonUtils';
import SkeletonLoader from '../../atoms/loader/SkeletonLoader';



export default function EditSection({ onClose, onCompletion, sectionID, item, isProfile, setAction }) {
    // console.log("EditSection--------------------------------", {sectionID, item, isProfile})
    const dispatch = useDispatch();
    const [selectedSection, setSelectedSection] = useState(item);
    const [loading, setLoading] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const elementOnfocus = useSelector(getElementOnFocus);
    const { register, handleSubmit, formState: { errors }, control, reset, setError, watch } = useForm({
        defaultValues: {
            name: selectedSection?.name,
            description: selectedSection?.attributes?.desc,
            visible: selectedSection?.attributes?.visible,
        }
    });

    useEffect(() => {
        setIsFetching(true);
        dispatch(invokeGetService('getSection', [sectionID])).then(res => {
            if (res?.status == true) {
                setSelectedSection(res?.data);

                let sectionData = {
                    name: res?.data?.name,
                    description: res?.data?.attributes?.desc,
                    visible: res?.data?.attributes?.visible,
                }
                if (res?.data?.attributes?.dimensions) {
                    const dimensionSplit = res.data.attributes.dimensions.split("x")
                    console.log(`width: ${dimensionSplit[0]}, height: ${dimensionSplit[1]}`)
                    sectionData.width = dimensionSplit[0]
                    sectionData.height = dimensionSplit[1]
                } else {
                    sectionData.width = 12
                    sectionData.height = 12
                }

                reset(sectionData);
            } else {
                if (res?.code === 255) {
                    onClose();
                }
            }
            setIsFetching(false);
        });
    }, [sectionID])



    const onUpdate = ({ name, description, visible, width, height }) => {
        setLoading(true);
        const sectionDataFormat = {
            name: name,
            attributes: {
                desc: description,
            }
        }

        if (visible !== "" && visible !== undefined) sectionDataFormat.attributes.visible = visible;

        //dimensions
        if (height !== '' && height !== undefined && width !== '' && width !== undefined) {
            sectionDataFormat.attributes.dimensions = `${width}x${height}`
        }

        dispatch(invokePostService('editSection', { section: sectionDataFormat, clusterletId: elementOnfocus?.id, isProfile }, [sectionID])).then(res => {
            setLoading(false);
            // console.log("Edit section resp -------------------------->", res.data)
            if (res?.status === true) {
                const errors = res?.data?.validationErrors ? res?.data?.validationErrors : [];
                dispatch(setExpanded("1"))
                onCompletion('Section', 'edit', errors, undefined, res?.data?.section);
            } else {
                if (res?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                    res?.errors.forEach(error => {
                        setError(error.name, { message: error.message });
                    });
                }
                if (res?.code === 255) {
                    onClose();
                }
            }
        });
    }

    const watchHeight = watch('height');
    const watchWidth = watch('width');


    const messages = { ...validationMessages, validate: 'This name is already used' };

    return (
        <>
            {
                isFetching === true ?
                    <SkeletonLoader rows={4} grid={[1,1,2,1]} />
                    :
                    <Grid container direction={"row"} spacing={3}>
                        <Grid item xs={12}>
                            <Typography >Edit section</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                name="name"
                                fullWidth
                                autoFocus
                                type={"text"}
                                required={true}
                                label={"Name"}
                                placeholder={""}
                                variant="outlined"

                                inputRef={register({ ...basic })}
                                error={errors?.name ? true : false}
                                helperText={errors?.name ? errors?.name?.message ? errors?.name?.message : messages[errors?.name?.type] : ''}
                            />
                        </Grid>


                        <Grid item xs={12}>
                            <TextField
                                id="description"
                                type={"text"}
                                fullWidth
                                rows={4}
                                label={"Description"}
                                placeholder={"Description"}
                                variant="outlined"
                                name="description"
                                inputRef={register({ required: false, validate: validateNonAsciiChars })}
                                error={errors?.description}
                                helperText={errors?.description?.message || ''}
                                multiline
                                minRows={2}
                            />
                        </Grid>

                        {/* width */}
                        {isProfile === false && <Grid item xs={6}>
                            
                            <Controller
                                name="width"
                                control={control}
                                // defaultValue={width}
                                render={({ field, value, onChange }) =>
                                    <TextField
                                        {...field}
                                        name="width"
                                        label={'Width'}
                                        select
                                        fullWidth
                                        variant={'outlined'}
                                        value={value}
                                        onChange={e => { onChange(e) }}
                                    >
                                        <MenuItem key={123} value={""}>Select</MenuItem>
                                        {fieldDimensionOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.title}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                }
                            />
                        </Grid>
                        }

                        {/* height */}
                        {isProfile === false &&
                            <Grid item xs={6}>
                                
                                <Controller
                                    name="height"
                                    control={control}
                                    // defaultValue={height}
                                    render={({ field, value, onChange }) =>
                                        <TextField
                                            {...field}
                                            name="height"
                                            label={'Height'}
                                            select
                                            fullWidth
                                            variant={'outlined'}
                                            value={value}
                                            onChange={e => { onChange(e) }}
                                        >
                                            <MenuItem key={123} value={""}>Select</MenuItem>
                                            {fieldDimensionOptions.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    {option.title}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    }
                                />
                            </Grid>
                        }



                        {isProfile === false && <Grid item xs={12}>
                            <Controller
                                name="visible"
                                control={control}
                                render={({ field, onChange }) =>
                                    <TextField
                                        {...field}
                                        name="visible"
                                        label={'Visibility'}
                                        select
                                        defaultValue={selectedSection?.attributes?.visible}
                                        fullWidth
                                        variant={'outlined'}
                                        onChange={e => { onChange(e) }}
                                    >
                                        <MenuItem key={123} value={""}>Select</MenuItem>
                                        {booleanOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.title}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                }
                            />
                        </Grid>}

                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end", marginBottom: 20 }} >
                            <UpdateCancel onUpdate={handleSubmit(onUpdate)} updateDisable={loading} content={loading ? 'Updating' : 'Update'} onCancel={onClose} typesNotIn={['transaction', 'view']} />
                        </Grid>
                    </Grid>
            }
        </>
    )
}